<template>
  <v-row>
    <v-col>
      <SurgeryListItem
        v-for="surgery in surgeries"
        :key="surgery.id"
        :surgery="surgery"
        :refreshList="refreshList"
      />
    </v-col>
  </v-row>
</template>

<script>
  import SurgeryListItem from "@/components/surgery/list/item.vue";

  export default {
    name: "SurgeryList",
    props: {
      attendance: Object,
    },
    components: {
      SurgeryListItem,
    },
    mounted(){
      this.refreshList();
    },
    apollo: {
      surgeries: {
        query: require("@/graphql/surgery/surgeries.gql"),
        variables() {
          return {
            attendanceId: this.attendance.id,
          };
        },
        update(data) {
          return this.lodash.orderBy(data.surgeries, ["createdAt"], ["desc"]);
        },
        pollInterval: 20000000,
      },
    },
    methods: {
      refreshList() {
        this.$apollo.queries.surgeries.refetch();
      },
    },
  };
</script>

<style lang="sass" scoped></style>
